export default __webpack_public_path__ + "static/Galaxy-fa685fe2253a1cdf22e45533b110fa2e.png";